

const DanishFlagIcon = ({ size, onClick }: { size: number; onClick?: () => void }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 100 100"
    onClick={onClick}
  >
    <mask
      id="mask0"
      style={{ maskType: "alpha" }}
      width="100"
      height="100"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <circle cx="50" cy="50" r="50" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0)">
      <path fill="#C60C30" d="M-30-8h154v116.541H-30V-8z" />
      <path
        fill="#fff"
        d="M-30 41.946h49.946V-8h16.649v49.946H124v16.649H36.595v49.946h-16.65V58.595H-30v-16.65z"
      />
    </g>
  </svg>
);

export default DanishFlagIcon;
